module.exports = __webpack_public_path__ + "static/media/dc_invoice_logo.295cc37f.svg";